import React from "react";

const Banner = ({ page, heading, subHeading }) => {
  return (
    <div
      className={`bg-${page} flex flex-col gap-4 justify-center items-center w-full h-[500px] px-10 xl:px-0`}
    >
      <div className="flex flex-col gap-4 justify-center w-full max-w-screen-xl ">
        <p className="sm:text-7xl text-white text-5xl">{heading}</p>
        {subHeading && <p className="text-7xl text-white">{subHeading}</p>}
      </div>
    </div>
  );
};

export default Banner;
